import React from 'react';
import {
  FileText,
  FileSignature,
  Folder,
  DollarSign,
  Heart,
  GraduationCap,
  Calendar,
  BarChart,
  Shield,
  Gift,
  Star
} from 'lucide-react';

/**
 * Mapeo de iconos según el código de categoría
 */
const iconMap = {
  legal: FileText,
  contractual: FileSignature,
  administrativo: Folder,
  nomina: DollarSign,
  medico: Heart,
  academico: GraduationCap,
  vacaciones: Calendar,
  evaluaciones: BarChart,
  seguridad: Shield,
  beneficios: Gift,
  especiales: Star
};

/**
 * Mapeo de colores según el código de categoría
 */
const colorMap = {
  legal: 'text-blue-600 bg-blue-50',
  contractual: 'text-purple-600 bg-purple-50',
  administrativo: 'text-orange-600 bg-orange-50',
  nomina: 'text-green-600 bg-green-50',
  medico: 'text-red-600 bg-red-50',
  academico: 'text-indigo-600 bg-indigo-50',
  vacaciones: 'text-cyan-600 bg-cyan-50',
  evaluaciones: 'text-pink-600 bg-pink-50',
  seguridad: 'text-gray-600 bg-gray-50',
  beneficios: 'text-yellow-600 bg-yellow-50',
  especiales: 'text-teal-600 bg-teal-50'
};

/**
 * Componente de icono de categoría
 */
export default function CategoryIcon({ categoria, size = 'md', withBackground = true }) {
  const Icon = iconMap[categoria] || FileText;
  const colorClass = colorMap[categoria] || 'text-gray-600 bg-gray-50';

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  const iconSizes = {
    sm: 16,
    md: 20,
    lg: 24
  };

  if (withBackground) {
    return (
      <div className={`
        ${sizeClasses[size]}
        ${colorClass}
        rounded-lg flex items-center justify-center
      `}>
        <Icon size={iconSizes[size]} />
      </div>
    );
  }

  return <Icon size={iconSizes[size]} className={colorClass.split(' ')[0]} />;
}
